(()=> {
  const colorOf = root => {
    const picker=root.querySelector('variant-picker');
    const selected=picker?.querySelector('input[data-option-name="色"]:checked, select option[selected][data-option-name="色"]');
    const value=(selected?.value || '').trim();
    return /黒|ブラック|black/i.test(value)?'black':/クリーム|cream|生成り/i.test(value)?'cream':'';
  };
  const classify = alt => /黒|ブラック|black/i.test(alt)?'black':/クリーム|cream|生成り/i.test(alt)?'cream':'';
  // 犬用：写真の下に、モデル犬の着用サイズを小さく表記（ブラック＝M／クリーム＝S）
  const MODEL_SIZE = { black: 'M', cream: 'S' };
  const modelNote = (gallery, root, color) => {
    const handle = root.querySelector('variant-picker')?.dataset?.productHandle || '';
    let note = gallery.querySelector('.fep-model-note');
    if (!/french-bulldog/.test(handle) || !MODEL_SIZE[color]) { if (note) note.remove(); return; }
    if (!note) {
      note = document.createElement('p');
      note.className = 'fep-model-note';
      note.style.cssText = 'grid-column:1/-1;margin:10px 0 0;padding-inline:20px;font-size:11px;line-height:1.8;letter-spacing:.06em;color:#696b62;text-align:left';
      gallery.appendChild(note);
    }
    const text = 'モデル犬（体重10.8kg・胴まわり54cm）着用サイズ：' + MODEL_SIZE[color];
    if (note.textContent !== text) note.textContent = text;
  };
  const apply = gallery => {
    if(!gallery || !gallery.isConnected) return;
    const root=gallery.closest('.product-information') || document;
    const color=colorOf(root);
    modelNote(gallery, root, color);
    const slides=Array.from(gallery.querySelectorAll('slideshow-slide'));
    const thumbs=Array.from(gallery.querySelectorAll('button.slideshow-controls__thumbnail'));
    if(!slides.length) return;
    const visible=[];
    let visiblePosition=0;
    slides.forEach((slide,index)=>{
      const image=slide.querySelector('img');
      const kind=classify(image?.alt || '');
      const show=!color || !kind || kind===color;
      slide.hidden=!show;
      slide.setAttribute('aria-hidden',show ? slide.getAttribute('aria-hidden') || 'false' : 'true');
      if(show) visible.push(index);
      const thumb=thumbs[index];
      if(thumb){
        thumb.hidden=!show;
        if(show){
          thumb.setAttribute('on:click','/select/'+visiblePosition);
          visiblePosition++;
        }
        const label='写真 ' + (show ? visiblePosition : 1) + ' / ' + Math.max(1,slides.filter(s=>{const k=classify(s.querySelector('img')?.alt||'');return !color||!k||k===color}).length); if(thumb.getAttribute('aria-label')!==label) thumb.setAttribute('aria-label',label);
        if(!thumb.dataset.fepHoverBound){
          thumb.dataset.fepHoverBound='true';
          thumb.addEventListener('pointerenter',()=>{if(matchMedia('(hover:hover) and (pointer:fine)').matches && !thumb.hidden && thumb.getAttribute('aria-selected')!=='true') thumb.click();});
        }
      }
    });
    // スマホの「●●●」：表示する写真の枚数ぶんだけ残し、あとは隠す（押したときの番号も、表示中の写真の順番に合わせる）
    const dots=Array.from(gallery.querySelectorAll('.slideshow-controls__dots button'));
    dots.forEach((b,i)=>{
      const li=b.closest('li');
      const show=i<visible.length;
      if(li) li.hidden=!show;
      b.setAttribute('on:click','/select/'+i);
      b.style.animationTimeline=color?'none':'';
    });
    // 色が変わったとき、スマホなど（一覧の小さい写真がない画面）では、先頭の写真に戻す
    if(gallery.dataset.fepColor!==color){
      const first=gallery.dataset.fepColor===undefined;
      gallery.dataset.fepColor=color;
      if(color && !thumbs.length && visible.length){
        const sl=gallery.slideshow || gallery.querySelector('slideshow-component');
        if(typeof sl?.select==='function') setTimeout(()=>{try{sl.select(0,undefined,{animate:false})}catch(e){}},first?400:50);
      }
    }
    const selected=thumbs.find(t=>t.getAttribute('aria-selected')==='true');
    if(selected?.hidden && visible.length) thumbs[visible[0]]?.click();
    if(!gallery.dataset.fepThumbnailsBound){
      gallery.dataset.fepThumbnailsBound='true';
      gallery.addEventListener('click',event=>{
        const thumb=event.target.closest('button.slideshow-controls__thumbnail');
        if(!thumb || thumb.hidden) return;
        const shown=Array.from(gallery.querySelectorAll('button.slideshow-controls__thumbnail')).filter(item=>!item.hidden);
        const index=shown.indexOf(thumb);
        const slideshow=gallery.slideshow || gallery.querySelector('slideshow-component');
        if(index<0 || typeof slideshow?.select!=='function') return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        slideshow.select(index,event);
      },true);
    }
    if(!gallery.dataset.fepArrowsBound){
      gallery.dataset.fepArrowsBound='true';
      gallery.addEventListener('click',event=>{
        const arrow=event.target.closest('button[aria-label*="次のスライド"],button[aria-label*="前のスライド"],button[aria-label*="Next slide"],button[aria-label*="Previous slide"]');
        if(!arrow)return;
        const shown=Array.from(gallery.querySelectorAll('button.slideshow-controls__thumbnail')).filter(t=>!t.hidden); if(!shown.length)return;
        event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();
        const at=shown.findIndex(t=>t.getAttribute('aria-selected')==='true');
        const forward=/次|Next/i.test(arrow.getAttribute('aria-label')||'');
        shown[(at+(forward?1:-1)+shown.length)%shown.length].click();
      },true);
    }
  };
  const run=()=>document.querySelectorAll('media-gallery').forEach(apply);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
  document.addEventListener('change',event=>{
    if(event.target.closest?.('variant-picker')){
      setTimeout(run,80);setTimeout(run,500);setTimeout(run,1100);
    }
  });
  new MutationObserver(run).observe(document.documentElement,{subtree:true,childList:true});
})();
